import { render, staticRenderFns } from "./ModuloConfiguracaoCampos.vue?vue&type=template&id=948a8464"
import script from "./ModuloConfiguracaoCampos.vue?vue&type=script&lang=ts"
export * from "./ModuloConfiguracaoCampos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports